

const ROUTES = {
    LANDING: '/',
    NO_ACCESS: '/no-access',
    DASHBOARD: '/dashboard',
    USERMANAGEMENT: '/user-management',
    QUESTIONMANAGEMENT: '/question-management',
    PLANTMANAGEMENT: '/plant-management',
    SCORINGMANAGEMENT: '/scoring-management'
};

export default ROUTES;


